import { useSearchState } from "apps/visits/core/modules/vouchers-distribution/store/use-search-state";
import { SearchInput } from "apps/visits/packages/ui/src/components";
import { useTranslation } from "react-i18next";

type SearchProps = {
  isLoading?: boolean;
  search: (searchTerm: string) => void;
  clearSearchResults: () => void;
};

export const Search = ({ isLoading, search, clearSearchResults }: SearchProps) => {
  const { t } = useTranslation();
  const { searchTerm } = useSearchState();

  const onSearch = (queryString: string) => {
    if (queryString.length === 0) return clearSearchResults();

    search(queryString);
  };

  return (
    <SearchInput
      name="search"
      value={searchTerm}
      className="h-14 border-foreground shadow-md"
      placeholder={t("VOUCHERS_DISTRIBUTION.SEARCH.PLACEHOLDER")}
      onChange={(e) => onSearch(e.target.value)}
      onClearSearch={() => clearSearchResults()}
      disabled={isLoading}
      data-testid="catalog-search-input"
    />
  );
};
